import { localStg } from '@/utils/storage';
import type { RequestInstanceState } from './type';

/** 获取用户登录凭证 */
export function getAuthorization() {
  const token = localStg.get('token');
  const Authorization = token ?? null;

  return Authorization;
}

export function showErrorMsg(state: RequestInstanceState, message: string) {
  if (!state.errMsgStack?.length) {
    state.errMsgStack = [];
  }

  const isExist = state.errMsgStack.includes(message);

  if (!isExist) {
    state.errMsgStack.push(message);

    window.$message?.error(message, 1.5, () => {
      state.errMsgStack = state.errMsgStack.filter(msg => msg !== message);

      setTimeout(() => {
        state.errMsgStack = [];
      }, 5000);
    });
  }
}
